export enum FeatureFlagBlockingMethod {
  Hide = "Hide",
  Block = "Block",
  Limitation = "Limitation",
}
